import { FormControl, FormErrorMessage, FormLabel } from "@chakra-ui/react";
import { GOVERNMENT_ID_OPTIONS } from "@equidefi/shared";
import Select from "react-select";

export const GovernmentIDType = ({ vault, setFieldValue, isDisabled, error, ...rest }) => {
  // Need to do this so the default value sets
  if (!vault) return null;

  return (
    <FormControl mb={5} isRequired isInvalid={error}>
      <FormLabel mt="0" p="0" fontSize="md">
        Government ID Type
      </FormLabel>
      <Select
        autoFocus={false}
        onChange={(value) => {
          setFieldValue("identification_type", value.value);
        }}
        isDisabled={isDisabled}
        placeholder={"Select Government ID Type"}
        defaultValue={GOVERNMENT_ID_OPTIONS.find(({ value }) => value === vault?.identification_type)}
        options={GOVERNMENT_ID_OPTIONS}
        components={{
          IndicatorSeparator: null,
        }}
        {...rest}
      />
      <FormErrorMessage>{error}</FormErrorMessage>
    </FormControl>
  );
};
